import styled from "styled-components";
import { responsive } from "../../../../styles/constants.style";

export const UsersSearchHeaderWrapper = styled.div`
  margin: 4px 0px 16px;
  .header-right {
    text-align: end;
    margin-top: 16px;

    .header-right-button {
      ${responsive.MOBILE`
        width:100%;
        margin-bottom:16px;
      `}
    }
  }
`;
